import { z } from 'zod'

const resultCountSchema = z.object({
  count_with_family_members: z.number().nonnegative(),
  count_without_family_members: z.number().nonnegative(),
})

const queryRecordResultCountSchema = z.record(z.string(), resultCountSchema)

export const searchResultCountsResponseSchema = z.object({
  data: z.object({
    search_query_result_counts: queryRecordResultCountSchema,
    search_query_intersection_result_counts: queryRecordResultCountSchema,
    saved_results_result_counts: resultCountSchema,
  }),
})
